import styled from "styled-components";
import { Theme } from "theme";

export const LeftBorderAltBackgroundTableCell = styled.td<{
  leftBorder?: boolean;
  alternateBackground?: boolean;
}>`
  ${({ leftBorder }) => leftBorder === true && "border-left: 1px solid black;"}
  ${({ alternateBackground }) =>
    alternateBackground === true &&
    `background: ${Theme.trackTimesBackground};`};
`;

export const TrackTableCell = styled(LeftBorderAltBackgroundTableCell)<{
  frozen?: boolean;
  frozenOffset?: boolean;
}>`
  text-align: center;
  margin: auto;
  padding: 2px 6px;
  white-space: nowrap;
  font-size: 11pt;
  ${({ frozen, frozenOffset }) =>
    frozen &&
    `position: sticky; left: ${frozenOffset ? 150 : 0}px; background: ${
      Theme.trackTimesAltBackground
    };`}
  ${({ frozenOffset }) => frozenOffset && "border-right: 1px solid;"}
  @media (max-width: 700px) {
    font-size: 10pt;
    padding: 2px 4px;
  }
`;
